import { GameEvent } from "./GameEvent.js";
import type { Move } from "../../../royalur/model/Move.js";


export class MoveGameEvent extends GameEvent {
    private readonly move: Move;
    private readonly skipAnimation: boolean;

    constructor(move: Move, skipAnimation: boolean) {
        super("move");
        this.move = move;
        this.skipAnimation = skipAnimation;
    }

    getMove(): Move {
        return this.move;
    }

    getSkipAnimation(): boolean {
        return this.skipAnimation;
    }
}
